import { EvaChartStates } from "types/factory";

import {
  BLUR_OPACITY,
  DEFAULT_WIDTH,
  DEFAULT_Z_INDEX,
  HIGHLIGHTED_WIDTH,
  HIGHLIGHTED_Z_INDEX
} from "../../translators/constants";
import { computeSelectionStates, getGroupNameFromLabel } from "../../translators/utils";

export function wellContributionHighlightedSeries(states: Partial<EvaChartStates>) {
  const {
    series,
    hoverLegendItem,
    hoverLegendGroup,
    attentionWells,
    selectedGroups = []
  } = states;

  const isOpaque = !(hoverLegendItem || selectedGroups.length > 0);

  return series
    .filter((s) => s.label.toLowerCase() !== "well count")
    .map((s, index) => {
      const { label, style } = s;

      const group = getGroupNameFromLabel(label);

      const { isHovered } = computeSelectionStates({
        hoverLegendItem,
        hoverLegendGroup,
        attentionWells,
        label,
        groupTitle: group,
        selectedGroups
      });

      const id =
        group && group != label ? `${group}, ${label}, ${index}` : `${label}, ${index}`;

      return {
        id,
        lineStyle: {
          width: isHovered ? HIGHLIGHTED_WIDTH : style?.thickness ?? DEFAULT_WIDTH,
          opacity: isOpaque ? 1 : isHovered ? 1 : BLUR_OPACITY
        },

        z: isHovered ? HIGHLIGHTED_Z_INDEX : DEFAULT_Z_INDEX
      };
    });
}
